@if (document) {
  <div class="procedure-document-viewer">
    @for (n of document.nodes; track $index) {
      <app-document-node-view [node]="n"></app-document-node-view>
    }
  </div>
} @else {
  <div class="empty">No document loaded</div>
}
